import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import './App.css';
import Input from '@mui/material/Input';
import { Button, InputLabel } from '@mui/material';
import UnpaidLicenseTable from './components/UnpaidLicenseTable/UnpaidLicenseTable';
import UnpaidLicense from './pages/UnpaidLicense/UnpaidLicense';
import Auth from './pages/Auth/Auth';
import Navbar from './components/Navbar/Navbar';
import Settings from './pages/Settings/Settings';
import Search from './pages/Search/Search';

function App() {

  return (<>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<UnpaidLicense/>}/>
          <Route path="/auth" element={<Auth/>}/>
          <Route path="/settings" element={<Settings />}/>
          <Route path="/search" element={<Search />}/>
        </Routes>
      </Router>
  </>);
}

export default App;
